export enum SortingOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export const DBSortingOrder = {
  [SortingOrder.ASC]: 1,
  [SortingOrder.DESC]: -1,
} as const

export type DBSortingOrderType = keyof typeof DBSortingOrder

export type PaginatedResult<T> = {
  items: T[]
  count: number
}
